// extracted by mini-css-extract-plugin
export default {"loginWidgetForm":"CloudLoginPage_loginWidgetForm__loTic","loginWidget":"CloudLoginPage_loginWidget__154Ex"};